import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { Toaster } from "@/components/ui/toaster";

const NotFound = () => (
  <div className="min-h-screen bg-[#0a0a0a] text-white flex flex-col items-center justify-center text-center px-8">
    <p className="text-xs tracking-[0.3em] uppercase text-silver mb-4">404</p>
    <h1 className="text-5xl md:text-7xl font-light mb-6">Page not found</h1>
    <p className="text-silver mb-10">The page you're looking for doesn't exist.</p>
    <Link to="/" className="text-sm text-white underline underline-offset-4 hover:text-soft-white transition-colors">
      Back to home
    </Link>
  </div>
);

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.25, ease: "easeInOut" }}
        style={{ backgroundColor: '#0a0a0a', minHeight: '100vh' }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <AnimatedRoutes />
        <Toaster />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
